import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Homepage from './pages/homepage';
import About from './pages/about';
import Contact from './pages/contact';
import Health from './pages/health';
import Wearable from './pages/wearable';
import Dashboard from './pages/dashboard';
import Login from './pages/login';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public site with sidebar nav */}
        <Route element={<Layout />}>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
        {/* Dashboard apps — no sidebar */}
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/health" element={<Health />} />
        <Route path="/wearable" element={<Wearable />} />
      </Routes>
    </Router>
  );
}

export default App;
